import { render } from "./WebsiteEdit.vue?vue&type=template&id=27866ff2&scoped=true"
import script from "./WebsiteEdit.vue?vue&type=script&lang=js"
export * from "./WebsiteEdit.vue?vue&type=script&lang=js"

import "./WebsiteEdit.vue?vue&type=style&index=0&id=27866ff2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27866ff2"]])

export default __exports__